module.exports = __webpack_public_path__ + "static/media/ceara.041fbfe9.svg";